import { api } from './index'

const TicketRequestService = {
  getTickets(params) {
    return api.get("tickets", params)
  },
  getTicket(id) {
    return api.get(`tickets/${id}`)
  },
  store(data) {
    return api.post("tickets", data)
  },
  update(id, data) {
    return api.post(`tickets/${id}/update`, data)
  },
  getCategories() {
    return api.get("tickets/categories")
  },
  getPriorities() {
    return api.get("tickets/priorities")
  },
  storeComment(ticketId, data) {
    return api.post(`/tickets/${ticketId}/store-comment`, data)
  },
  getTotal() {
    return api.get('/tickets/count')
  },
  getCountTicketsCategories() {
    return api.get('/tickets/count-ticket-categories')
  },
  getCountTicketsPriorities() {
    return api.get('/tickets/count-ticket-priorities')
  },
  getCountTicketsTime() {
    return api.get('/tickets/count-ticket-days')
  },
  getCountTicketsDate() {
    return api.get('/tickets/count-ticket-date')
  }
}

export default TicketRequestService